import React, { useState } from 'react';
import { Toast } from '../../../components/common/Toast';
import { CopyClipboardIcon, DeleteIcon, EditIcon, LegalPageIcon, ViewIcon } from '../../../components/common/SvgIcon';

const TableRow = ({ page, onDelete }) => {
  console.log("page",page);
  const [copiedShortcode, setCopiedShortcode] = useState(false);

  const copyShortcode = (shortcode) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(shortcode)
        .then(() => {
          Toast.success('Shortcode copied!');
          setCopiedShortcode(true);
          setTimeout(() => setCopiedShortcode(false), 2000);
        })
        .catch(() => fallbackCopy(shortcode));
    } else {
      fallbackCopy(shortcode);
    }
  };

  const fallbackCopy = (text) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      Toast.success('Shortcode copied!');
      setCopiedShortcode(true);
      setTimeout(() => setCopiedShortcode(false), 2000);
    } catch (err) {
      Toast.error('Failed to copy');
    }
    document.body.removeChild(textArea);
  };

  return (
    <tr className="h-[68px] border-b border-[#E4E4E7] hover:bg-gray-50 transition-colors">
      {/* ID */}
      <td className="py-4 px-4">
        <span className="text-sm font-medium text-[#6F6F7B]">#{page.id}</span>
      </td>

      {/* Title */}
      <td className="py-4 px-4">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 bg-[#7C3BED]/10 rounded-xl flex items-center justify-center flex-shrink-0">
            <LegalPageIcon />
          </div>
          <div>
            <div className="text-sm font-semibold text-[#17171C]">{page.title}</div>
            <div className="text-xs text-[#6F6F7B]">{page.subtitle || 'Legal Page'}</div>
          </div>
        </div>
      </td>

      {/* Author */}
      <td className="py-4 px-4">
        <span className="text-sm text-[#6F6F7B]">{page.author}</span>
      </td>

      {/* Created At */}
      <td className="py-4 px-4">
        <span className="text-sm text-[#6F6F7B]">{page.created_at}</span>
      </td>

      {/* Shortcode */}
      <td className="py-4 px-4">
        <button
          onClick={() => copyShortcode(page.shortcode)}
          className="inline-flex items-center gap-[10px] px-3 py-1.5 bg-[#7C3BED]/5 hover:bg-[#7C3BED]/10 text-[#7C3BED] rounded-md text-xs font-mono transition-colors"
        >
          <span>{page.shortcode}</span>
          {copiedShortcode ? (
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          ) : (
            <CopyClipboardIcon />
          )}
        </button>
      </td>

      {/* Actions */}
      <td className="py-4 px-4">
        <div className="flex items-center gap-2">
          {/* View */}
          <a
            href={page.view_url}
            target="_blank"
            rel="noopener noreferrer"
            className="p-2 text-[#6F6F7B] cursor-pointer hover:text-[#7C3BED] hover:bg-[#7C3BED]/5 rounded-xl transition-colors"
            title="View page"
          >
            <ViewIcon />
          </a>

          {/* Edit */}
          <a
            href={page.edit_url}
            target="_blank"
            rel="noopener noreferrer"
            className="p-2 text-[#6F6F7B] cursor-pointer hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-colors"
            title="Edit page"
          >
            <EditIcon />
          </a>

          {/* Delete */}
          <button
            onClick={() => onDelete(page.id, page.title)}
            className="p-2 text-[#6F6F7B] cursor-pointer hover:text-red-600 hover:bg-red-50 rounded-xl transition-colors"
            title="Delete page"
          >
            <DeleteIcon />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default TableRow;